export default __webpack_public_path__ + "static/media/Unify_Logo_White.379c96a9.svg";